<mat-card appearance="outlined" class="mat-elevation-z8">
  <form [formGroup]="frmClientUser" novalidate>
    <h4>{{edit === true ? 'Edit ' : 'New ' }} User</h4>
    <div class="flex-row">
      <div class="flex-column">
        <label class="field__label">First Name</label>
        <input class="field__control" id="firstName" required formControlName="firstName">
        @if (frmClientUser.controls.firstName.invalid && frmClientUser.controls.firstName.touched) {
          <span class="field__error">First name required</span>
        }
      </div>
      <div class="flex-column">
        <label class="field__label">Last Name</label>
        <input class="field__control body-content" formControlName="lastName" required />
        @if (frmClientUser.controls.lastName.invalid && frmClientUser.controls.lastName.touched) {
          <span class="field__error">Last name required</span>
        }
      </div>
      <div class="flex-column">
        <label class="field__label">Email</label>
        <input class="field__control body-content" formControlName="email" required [readonly]="edit" />
        @if (frmClientUser.controls.email.invalid && frmClientUser.controls.email.touched) {
          <span class="field__error">Email required</span>
        }
      </div>
      <div class="flex-column">
        <label class="field__label">Mobile</label>
        <input class="field__control body-content" [pattern]="mobNumberPattern" formControlName="mobileNumber" [attr.required]="mfaCheckbox.checked ? '' : null" />
        @if (frmClientUser.controls.mobileNumber.invalid && frmClientUser.controls.mobileNumber.touched) {
          <span class="field__error">Enter a valid mobile number</span>
        }
      </div>
      <div class="flex-column">
        <h4>Multi Factor Authentication</h4>
        <label class="field__checkbox"><input type="checkbox" #mfaCheckbox formControlName="mfaEnabled" /></label>
      </div>
    </div>
    <div>
      <div class="flex-row">
        <div class="flex-column">
          <label class="field__label">Client Filter</label>
          <app-searchable-select [items]="clientList" displayField="dropdownDisplay" valueField="clientId"
            multiple placeholder="Select clients" searchPlaceholder="Search clients…"
            (selectionChange)="onClientFilterChange($event)"></app-searchable-select>
        </div>
      </div>
      <mat-table #table [dataSource]="dataSource">
        <ng-container matColumnDef="clientname">
          <mat-header-cell *matHeaderCellDef>
            Client
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            @if (element.clientName.length> 0) {
              <span class="mobile-label">Client</span>
            }
            {{element.clientName}} ({{element.clientId}})
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="role">
          <mat-header-cell *matHeaderCellDef>
            Roles
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            @for (chk of userRoles; track chk) {
              <div>
                <label class="field__checkbox"><input type="checkbox" [checked]="checked(element,chk)" [disabled]="onDisabled(element,chk)" (change)="assignCheckbox(element, chk, {checked: $event.target.checked})" /> {{chk.role}}</label>
              </div>
            }
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <!--<mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [cdkDetailRow]="row" [cdkDetailRowTpl]="tpl" (click)="onClick(row)"></mat-row>-->
        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"></mat-row>
      </mat-table>
    </div>
    <div class="div-flex-buttons">
      <div class="div-padding-right-10"><button class="btn btn-primary" id="Save" name="Save" value="Save" (click)="saveUser()">Save</button></div>
      <div class="divclose"><button class="btn btn-primary" id="Close" name="Close" value="Close" (click)="close()">Close</button></div>
    </div>
  </form>
</mat-card>
